define('shoptheme/components/layout/home',[
	"jquery",
	"cartware/components/_base",
	"cartware/components/Holepunch"
], function(
	$,
	Component,
	Holepunch
) {
	return Component.create({
		constructor: function() {
			Holepunch.ready(function(data) {
				//console.log("HOLEPUNCH", data);
			});
		},
		$init: function() {
			//console.log("DOM READY");
		}
	});
});
